import React from 'react';
import classnames from 'classnames';

import {
  Button, Icon, Image, Price
} from 'components/ui';
import { IMAGES } from 'constants/images';
import { useDrawerDispatchHelpers } from 'context/DrawerContext';
import { DRAWER_TYPES } from 'helpers/LayoutHelpers';
import { getHolidayImageSrc, isEasterSeason } from 'helpers/SeasonalHelpers';
import { useActiveOrder } from 'hooks/data/useActiveOrder';

import styles from './HeaderCartButton.module.scss';

interface Props {
  className?: string,
  btnClassName?: string,
  hideCartOnLargeScreens?: boolean,
  isMobile?: boolean
}

const CartButton = (props: Props) => {
  const {
    className,
    btnClassName,
    hideCartOnLargeScreens,
    isMobile
  } = props;

  const { data: order } = useActiveOrder();
  const { items = [], itemsTotal, currency } = order || {};
  const { showDrawer } = useDrawerDispatchHelpers();

  const handleClick = () => showDrawer(DRAWER_TYPES.CART);

  const classes = classnames(
    styles.root,
    { [styles.alwaysShowCartButton]: !hideCartOnLargeScreens },
    { [styles.mobile]: isMobile },
    className
  );

  const isPriceVisible = !isMobile && Number(itemsTotal) > 0;

  return (
    <div className={classes}>
      <Button
        className={classnames(styles.button, btnClassName)}
        size="medium"
        variant={isMobile ? 'subtle' : 'primary'}
        aria-label="Cart"
        onClick={handleClick}
      >
        {isPriceVisible && <Price currency={currency} value={itemsTotal} className={styles.price} />}
        {isEasterSeason() ? HolidayImage : <Icon name="cart-arrow" size={22} />}
      </Button>
      <div className={styles.quantityWrapper}>
        <div className={styles.quantity}>
          {items?.length || 0}
        </div>
      </div>
    </div>
  );
};

const HolidayImage = <Image height={22} width={22} src={getHolidayImageSrc({ easterIcon: IMAGES.SEASONAL.EASTER_BASKET })} />;

export default CartButton;
